import {
  GET_CAMPAIGN_RESULTS,
  GET_CAMPAIGN_RESULTS_SUCCESS,
  CREATE_CAMPAIGN,
  CREATE_CAMPAIGN_SUCCESS,
  UPDATE_CAMPAIGN,
  UPDATE_CAMPAIGN_SUCCESS,
  GET_CAMPAIGN_BY_ID,
  GET_CAMPAIGN_BY_ID_SUCCESS,
  GET_CAMPAIGNS,
  GET_ACTIVE_CAMPAIGNS_SUCCESS,
  GET_CAMPAIGNS_ERROR,
} from './const'
import createMiddleware from '../../Reducers/createMiddleware'
import {
  getCampaignResults,
  createCampaign,
  updateCampaign,
  getCampaignById,
  getCampaigns,
} from '../../Module/graphQL'

export const getCampaignResultsMiddleware = createMiddleware({
  actions: [GET_CAMPAIGN_RESULTS, GET_CAMPAIGN_RESULTS_SUCCESS],
  fetchMethod: (authToken, payload) => {
    return getCampaignResults(authToken, payload.campaignId)
  },
})

export const createCampaignMiddleware = createMiddleware({
  actions: [CREATE_CAMPAIGN, CREATE_CAMPAIGN_SUCCESS],
  fetchMethod: (authToken, payload) => createCampaign(payload),
})

export const updateCampaignMiddleware = createMiddleware({
  actions: [UPDATE_CAMPAIGN, UPDATE_CAMPAIGN_SUCCESS],
  fetchMethod: (authToken, payload) => updateCampaign(payload),
})

export const getCampaignByIdMiddleware = createMiddleware({
  actions: [GET_CAMPAIGN_BY_ID, GET_CAMPAIGN_BY_ID_SUCCESS],
  fetchMethod: (authToken, payload) =>
    getCampaignById(payload.campaignId, payload.options),
})

export const getActiveCampaignsMiddleware = createMiddleware({
  actions: [GET_CAMPAIGNS, GET_ACTIVE_CAMPAIGNS_SUCCESS, GET_CAMPAIGNS_ERROR],
  fetchMethod: (authToken, payload) => {
    return getCampaigns(payload)
  },
})
